export default __webpack_public_path__ + "static/media/frontpage.173a1af9.txt";